module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/social/google-9906c8d7ed5f8dd696b1373d19087da9.svg";